
  import { Component, Vue } from 'vue-property-decorator'
  import AuthRepository from '@/services/Auth'
  import ListItemHover from '@/components/base/ListItemHover.vue'

  @Component({
    components: {
      ListItemHover,
    },
    inject: [
      'authRepository',
    ],
  })
  export default class LogoutBtn extends Vue {
    private readonly authRepository!: AuthRepository
    private logoutText: string = 'Logout'

    private async logout(): Promise<void> {
      await this.authRepository.logout()
      this.$socket.disconnect();
      await this.$router.push({ name: 'auth_login' })
    }
  }
